/* eslint-disable simple-import-sort/imports */
// english namespaces imports
import CommonEnUS from './en-US/Common.json'

export const TRANSLATIONS_EN_US = {
  Common: CommonEnUS,
}
